export const seoTypes = {
  MetadataService: Symbol.for('SeoMetadataService'),

  GetMetadataUseCase: Symbol.for('SeoGetMetadataUseCase'),
}
